import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';

import { dataGridCol } from '@shared/components/grid/common';
import { deCamelize } from '@shared/commonFunctions';
import { statesList } from '@shared/constants/statesList';
import { GridColSelect } from '@shared/components/grid/GridColSelect';
import { DEAL_TYPES, DEAL_TYPES_VALUES } from '../constants';

export const useStateTitleDocumentColumns = () => {
  const columns = useMemo<GridColDef[]>(
    () => [
      dataGridCol('state', {
        editable: true,
        headerName: 'State',
        flex:1.5,
        minWidth: 80,
        valueGetter: (params) => params.value ? deCamelize(params.value) : '',
        renderEditCell: (params) => <GridColSelect isSearchable hideNoneOption options={statesList} params={params} />
      }),
      dataGridCol('dealBorrowerType', {
        editable: true,
        headerName: 'Deal Type',
        flex: 1.5,
        minWidth: 120,
        valueGetter: (params) => DEAL_TYPES_VALUES[params.value],
        valueFormatter: (params) => deCamelize(Object.keys(DEAL_TYPES_VALUES).find((key) => DEAL_TYPES_VALUES[key as keyof typeof DEAL_TYPES_VALUES] === params.value)),
        renderEditCell: (params) => <GridColSelect hideNoneOption options={DEAL_TYPES} params={params} />
      }),
      dataGridCol('documentName', {
        editable: true,
        flex: 3,
        maxWidth: undefined,
        minWidth: 240,
      }),
    ],
    [],
  );

  return { columns };
};
